export const GetUser = async ( firebase, uid ) => {

  try {
    const data = await firebase
      .firestore()
      .collection( "users" )
      .doc( uid )
      .get()

    return data.data()

  } catch ( error ) {
    console.log( 'get user', { error } )
  }

}

export default GetUser